// Hexagon.js
import React from "react";

const Hexagon = () => {
  return (
    <div
      className="w-48 h-48 bg-blue-500 transition-transform duration-300 ease-in-out hover:scale-110 hover:bg-blue-600"
      style={{
        clipPath: "polygon(25% 6.7%, 75% 6.7%, 100% 50%, 75% 93.3%, 25% 93.3%, 0% 50%)",
      }}
    />
  );
};

export default Hexagon;
